const DEFAULT_LEGAL_ENTITY = 'Hey Group GmbH';

const LEGAL_ENTITY_BY_LOCALE: Record<string, string> = {
  'en-uk': 'HEYCATER! UK LTD',
};

export function legalEntityName(locale?: string | null): string {
  return (
    (locale && LEGAL_ENTITY_BY_LOCALE[locale.toLowerCase()]) ||
    DEFAULT_LEGAL_ENTITY
  );
}
